import React, { useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import StaffManagement from './StaffManagement';
import AttendanceSheet from './AttendanceSheet';
import ReportGenerator from './ReportGenerate';
import AttendanceManager from './AttendanceManager';

const AttendanceSystem = () => {
  const [view, setView] = useState('staff');
  const [date, setDate] = useState(new Date()); // Add date state

  return (
    <div className="p-4">
      <div className="pt-10 mt-3">
        <div className="flex justify-start gap-4">
          <button
            className={`btn p-2 hover:text-[#AB3430] transition-all duration-300 ${
              view === 'staff' 
                ? 'text-[#AB3430] border-b border-[#AB3430]' 
                : 'border-b border-transparent'
            }`}
            onClick={() => setView('staff')}
          >
            Staff Management
          </button>

          {/* <button
            className={`btn p-2 hover:text-[#AB3430] transition-all duration-300 ${
              view === 'attendance' 
                ? 'text-[#AB3430] border-b border-[#AB3430]' 
                : 'border-b border-transparent'
            }`}
            onClick={() => setView('attendance')}
          >
            Attendance
          </button> */}
          
          <button
            className={`btn p-2 hover:text-[#AB3430] transition-all duration-300 ${
              view === 'report' 
                ? 'text-[#AB3430] border-b border-[#AB3430]' 
                : 'border-b border-transparent'
            }`}
            onClick={() => setView('report')}
          >
            Attendance / Reports
          </button>
        </div>

        {/* Main content area */}
        <div className="mt-4">
          {view === 'staff' && <StaffManagement />}
          {/* {view === 'attendance' && (
            <AttendanceSheet 
              date={date} 
              setDate={setDate} 
            />
          )} */}
          {view === 'report' && <AttendanceManager/>}
        </div>
      </div>
    </div>
  );
};

export default AttendanceSystem;